import React, { Component } from "react";
import '../Configuration.css';
import { Box, Paper, TextField, Button, Stack, Typography, Tooltip, Grid, FormControl, InputLabel, Select, MenuItem, Autocomplete, TableHead, TableRow, TableCell, Table, TableBody, Tab, InputAdornment, IconButton, TablePagination, Collapse, } from "@mui/material";
import { withTranslation } from 'react-i18next';
import { CommonDeleteButton, CommonEditButton, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";
import { Colors } from "../../../Styles/Colors";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";
import { DateTime } from 'luxon';
import { CurrencySymbol } from "../../../Utility/Constants";
import SearchIcon from '@mui/icons-material/Search';
import { ImagePaths } from "../../../Utility/ImagePaths";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

class CorporateService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceTempDetail: [],
            serviceNameandType: [],
            data: [],
            deleteId: null,
            srcTemplate_name: "",
            id: null,
            template_name: "",
            description: "",
            service_id: null,
            data: [],
            selectedItem: {},
            editIndex: -1,
            deletedPopup: false,
            isEdit: false,
            current_page: 0,
            rowsPerPage: 10,
            showSuccessResponse: false,
            showErrorResponse: false,
            responseMessage: "",
            clinicAmt: '',
            surgeryAmt: '',
            opNewServiceTypeData: [],
            opNewServiceType: null,
            opNewServiceNameData: [],
            opNewServiceName: null,
            newServiceListData: [],
            newServiceList: [],

            corpCompanyList: [],
            SelectedCorp: null,
            TotalAmount: "",
            DoctorFee: "",
            HospitalFee: "",
            serviceType: null,
            selectedIndex: null,
            page: 0,
            rowsPerPage: 10,
            isFromRightEdit: false,
            rightIndex: null
        }
    }

    componentDidMount() {
        this.getCorporateList();
        this._getServiceTempDetails();
        this._getServiceNameandType();
        this.getOpNewServiceData()
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    getCorporateList() {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE).
                then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            corpCompanyList: response.data.data
                        })
                    }
                    else {
                        this.responseSuccessErrorMessage(response.data.message, false)
                    }
                }).catch((error) => {
                    this.responseSuccessErrorMessage(error.message, false)
                })
        }
        catch (e) {
            this.responseSuccessErrorMessage(e.message, false)
        }
    }

    _getServiceTempDetails = () => {
        this.setState({
            serviceTempDetail: [],
            current_page: 0,
            rowsPerPage: 10
        })
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(`${Serviceurls.FO_CORPORATE_SERVICE_CONFIG}`)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            serviceTempDetail: response.data.data,
                            duplicateServiceData: JSON.stringify(response.data.data),
                        }, () => {
                            this.state.serviceTempDetail.forEach((item, i) => {
                                item.index = i
                            })
                            this.LoaderFunction(false)
                        });
                    }
                })
                .catch(error => {
                    this.LoaderFunction(false)
                    if (error.response.data.status === "fail") {
                        this.responseSuccessErrorMessage(error.response?.data?.message, false);
                    }
                });
        } catch (e) {
            this.LoaderFunction(false)
            this.responseSuccessErrorMessage(e.message, false);
        }
    }

    _getServiceNameandType = () => {
        this.setState({
            serviceNameandType: []
        })
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSRCNAMEANDTYPE)
                .then(response => {
                    if (response?.data?.status === "success") {
                        this.setState({
                            serviceNameandType: response?.data?.data,
                        })
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        this.responseSuccessErrorMessage(error.response?.data?.message, false);
                    }
                });
        } catch (e) {
            this.responseSuccessErrorMessage(e.message, false);
        }
    }

    getOpNewServiceData = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_NEW_OP_SERVICE_CONFIG + "?service_type=")
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            opNewServiceTypeData: response.data.data
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.responseSuccessErrorMessage(error.response.data.message, false);
                    } else {
                        this.responseSuccessErrorMessage(error.message, false);
                    }
                })
        } catch (error) {
            this.responseSuccessErrorMessage(error.message, false);
        }
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: +event.target.value, page: 0 });
    }

    responseSuccessErrorMessage(message, type) {
        this.setState({
            showSuccessResponse: message ? type : false,
            showErrorResponse: message ? !type : false,
            responseMessage: message
        })
    }

    handleDelete = (value, deleteAll = false) => {
        if (!this.state.isEdit) {
            const formattedValue = Array.isArray(value) ? value : [value];
            const ids = deleteAll
                ? formattedValue.flatMap(company => company.data.map(item => item.id))
                : null;
            this.setState({
                deletedPopup: true,
                deleteId: deleteAll ? ids : value?.id,
                srcTemplate_name: deleteAll ? value?.company_name : `${value?.service_name} - ${value?.service_type}`
            });
        } else {
            this.responseSuccessErrorMessage("Edit has been clicked.So,Please clear or Update service", false)
        }
    };

    PopupClose = () => {
        this.setState({
            deletedPopup: false,
            deleteId: null,
            srcTemplate_name: ""
        })
    }

    removeDataList = () => {
        try {
            RestAPIService.delete(`${Serviceurls.FO_CORPORATE_SERVICE_CONFIG}?id=${this.state.deleteId ? this.state.deleteId : 0}`)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            deletedPopup: false,
                            deleteId: null,
                            srcTemplate_name: ""
                        }, () => {
                            this.responseSuccessErrorMessage(response.data.message, true);
                            if (this.state.rightIndex || this.state.rightIndex == 0) {
                                this.state.newServiceList.splice(this.state.rightIndex, 1)
                                this.setState({ newServiceList: this.state.newServiceList, rightIndex: null })
                            } else {
                                this._getServiceTempDetails();
                            }
                        })
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        this.responseSuccessErrorMessage(error.response.data.message, false);
                    }
                });
        } catch (e) {
            this.responseSuccessErrorMessage(e.message, false);
        }
    }

    handleChange = (event) => {
        let states = this.state
        let name = event.target.name;
        let value = event.target.value.trimStart();
        if (name === "template_name") {
            let isValid = CommonValidation.alphanumValidation(value)
            if (value === "" || isValid) {
                states[name] = value;
            }
        } else if (name === "description") {
            if (value === "" || value.length <= 250) {
                states["description"] = value;
            }
        }
        this.setState({
            states
        })
    }

    handleClear = () => {
        let states = this.state;
        states["template_name"] = "";
        states["description"] = "";
        states["selectedItem"] = {};
        states["data"] = [];
        states["id"] = null;
        states["isEdit"] = false;
        states["isFromRightEdit"] = false;
        states["editIndex"] = -1;
        states["opNewServiceType"] = null;
        states["opNewServiceName"] = null;
        states["SelectedCorp"] = null;
        states["TotalAmount"] = "";
        states["DoctorFee"] = "";
        states["HospitalFee"] = "";
        states['newServiceList'] = [];
        this.setState({
            states
        })
    }

    renderTextBox(label, statekey, value, width) {
        const { t } = this.props;
        let { serviceNameandType, selectedItem } = this.state
        return (
            <div id="eMed_srvConfig_divs">
                {
                    statekey === "service_name" ?
                        <FormControl sx={{ width: width ? width : "11vw" }} size="small">
                            <InputLabel>{t(label) + " *"}</InputLabel>
                            <Select
                                value={value ? value : ""}
                                name={statekey}
                                label={t(label) + " *"}
                                onChange={(event) => {
                                    selectedItem["service_name"] = event.target.value;
                                    this.setState({
                                        selectedItem
                                    })
                                }}
                                MenuProps={{
                                    style: { maxHeight: 350 },
                                }}
                            >
                                <MenuItem value={""} >{"Select"}</MenuItem>
                                {
                                    serviceNameandType?.length > 0 ? serviceNameandType.map((list, index) => (
                                        <MenuItem key={index} value={list.service_name} >{list.service_name}</MenuItem>
                                    ))
                                        : null
                                }
                            </Select>
                        </FormControl>
                        :
                        statekey === "service_type" ?
                            <FormControl sx={{ width: width ? width : "11vw" }} size="small">
                                <InputLabel>{t(label) + " *"}</InputLabel>
                                <Select
                                    value={value ? value : ""}
                                    name={statekey}
                                    label={t(label) + " *"}
                                    onChange={(event) => {
                                        selectedItem["service_type"] = event.target.value;
                                        this.setState({
                                            selectedItem
                                        })
                                    }}
                                    MenuProps={{
                                        style: { maxHeight: 350 },
                                    }}
                                >
                                    <MenuItem value={""} >{"Select"}</MenuItem>
                                    {serviceNameandType?.length > 0 ? serviceNameandType.map((item) => {
                                        return item?.service_name === this.state.selectedItem["service_name"] ?
                                            item?.data.map((i, index) => (
                                                <MenuItem key={index} value={i.service_type} >{i.service_type}</MenuItem>
                                            )) : null
                                    }) : null
                                    }
                                </Select>
                            </FormControl> :
                            <TextField
                                sx={{ width: width ? width : "10vw" }}
                                size="small"
                                autoComplete="off"
                                label={t(label)}
                                name={statekey}
                                required={statekey === "description" ? false : true}
                                value={value ? value : ""}
                                multiline={statekey === "description" ? true : false}
                                rows={statekey === "description" ? 3 : null}
                                onChange={this.handleChange}
                            />
                }
            </div>
        )
    }

    handleSave = () => {
        const { t } = this.props
        try {
            let data = this.state.newServiceList.map(item => ({
                id: this.state.isEdit ? item?.ids : null,
                service_id: item.id,
                employer_id: item.employer_id,
                doctor_share: item?.doctor_share ? item?.doctor_share : 0,
                hospital_share: item?.hospital_share ? item?.hospital_share : 0,
                total_amount: item?.total_amount ? item?.total_amount : item.total_amt ? item.total_amt : 0,
                service_catagory_name: item?.service_catagory_name ? item?.service_catagory_name : item.service_catagory__catagory_name,
                service_catagory_id: item?.service_id ? item?.service_id : item.service_catagory_id,
            }));
            if (data?.length > 0 && this.state.newServiceList.length > 0) {
                this.LoaderFunction(true)
                RestAPIService.create(data, Serviceurls.FO_CORPORATE_SERVICE_CONFIG)
                    .then(response => {
                        if (response.data.status === "success") {
                            this.setState({
                                isEdit: false,
                                template_name: '',
                                description: '',
                                newServiceList: [],
                                selectedEditIndex: null,
                                SelectedCorp: null,
                                TotalAmount: "",
                                DoctorFee: "",
                                HospitalFee: "",
                                serviceType: null
                            })
                            this._getServiceTempDetails();
                            this.getOpNewServiceData()
                            this.LoaderFunction(false)
                            this.responseSuccessErrorMessage(response.data.message, true);
                        }
                    })
                    .catch(error => {
                        if (error?.response?.data?.status === "fail") {
                            this.LoaderFunction(false)
                            this.responseSuccessErrorMessage(error.response.data.message, false);
                        }
                    });
            } else {
                this.responseSuccessErrorMessage("Enter all mandatory fields", false)
            }
        } catch (e) {
            this.responseSuccessErrorMessage(e.message, false);
        }
    }

    msgClose() {
        this.setState({
            showSuccessResponse: false,
            showErrorResponse: false,
            responseMessage: ''
        })
    }

    newServiceEdit = (item, index) => {
        try {
            let corporate = this.state.corpCompanyList.filter((list) => list.id == item?.employer_id)
            let serviceType = this.state.opNewServiceTypeData.filter((list) => list.service_type == item?.service_type && (list?.service_catagory__catagory_name == item?.service_catagory__catagory_name || list?.service_catagory == item?.service_catagory__catagory_name))
            let serviceName = serviceType[0]?.data?.filter((list) => list.service_name == item?.service_name)
            this.setState({
                selectedEditIndex: index,
                opNewServiceName: serviceName?.[0],
                opNewServiceNameData: serviceType[0]?.data,
                opNewServiceType: serviceType?.[0],
                TotalAmount: item?.total_amt ? item?.total_amt : item?.total_amount || 0,
                DoctorFee: item?.doctor_share,
                HospitalFee: item?.hospital_share,
                SelectedCorp: corporate?.[0],
                serviceType: item?.service_type_name,
                isFromRightEdit: true
            })
        } catch (error) {
            this.responseSuccessErrorMessage(error.message, false)
        }
    }

    newServiceDelete = (item, index) => {
        try {
            if (!item?.company_name && !item?.ids) {
                this.state.newServiceList.splice(index, 1)
                this.setState({ newServiceList: this.state.newServiceList, rightIndex: null })
            } else {
                this.setState({
                    deleteId: item?.ids ? item?.ids : item?.id,
                    srcTemplate_name: `${item?.service_name} - ${item?.service_type}`,
                    rightIndex: index
                }, () => { this.removeDataList() });
            }
        } catch (error) {
            this.responseSuccessErrorMessage(error.message, false)
        }
    }

    onEditHandler = (item) => {
        try {
            if (!this.state.isFromRightEdit) {
                let data = item?.data.map(item => ({
                    ...item,
                    ids: item?.id,
                }));
                let corporate = this.state.corpCompanyList?.filter((list) => list.id == data[0]?.employer_id)
                this.setState({
                    newServiceList: data,
                    SelectedCorp: corporate?.[0]
                })
            } else {
                this.responseSuccessErrorMessage("Edit has been clicked.So,Please clear or Update service", false)
            }
        } catch (error) {
            this.responseSuccessErrorMessage(error.message, false)
        }
    }

    onSearchHandler = (e) => {
        try {
            this.setState({
                searchValue: e.target.value
            }, () => {
                let duplicateServiceData = JSON.parse(this.state.duplicateServiceData)
                if (this.state.searchValue !== '') {
                    duplicateServiceData = duplicateServiceData.filter((item) => {
                        return (
                            (item?.company_name === '' ? '' : item?.company_name?.toLowerCase()?.includes(this.state.searchValue?.toLowerCase()))
                        )
                    })
                    this.setState({ serviceTempDetail: duplicateServiceData })
                } else {
                    this.setState({ serviceTempDetail: duplicateServiceData })
                }
            })
        } catch (error) {
            this.responseSuccessErrorMessage(error.message, false)
        }
    }

    renderLeftContent = () => {
        this.state.serviceTempDetail.forEach((element, index) => element.sno = index + 1)
        return (
            <Box component={'div'} height={'79dvh'} overflow={'auto'}>
                <Box component={'div'} height={'5vh'} alignItems={'center'} display={'flex'} justifyContent={'flex-end'} pr={'1vw'}>
                    <TextField
                        size='small'
                        variant='standard'
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>)
                        }}
                        placeholder='Search...'
                        onChange={(e) => this.onSearchHandler(e)}
                        autoComplete='off'
                    />
                </Box>
                <Box component={'div'}>
                    <Box component={'div'} stickyHeader sx={{ height: '65dvh', overflow: 'scroll' }}>
                        <Table size='small' >
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                        <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={'0.9vw'}>S.No</Typography>
                                    </TableCell>
                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                        <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={'0.9vw'}>Company Name</Typography>
                                    </TableCell>
                                    <TableCell sx={{ backgroundColor: Colors.Background }} align='center'>
                                        <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={'0.9vw'}>Action</Typography>
                                    </TableCell>
                                    <TableCell sx={{ backgroundColor: Colors.Background }}></TableCell>
                                </TableRow>
                            </TableHead>
                            {this.state.serviceTempDetail?.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage +
                                this.state.rowsPerPage).map((item, index) => (
                                    <TableBody style={{ height: "1.5vw" }}>
                                        <><TableRow key={index} style={{ height: "1.5vw" }}>
                                            <TableCell>
                                                <Typography>{item?.sno}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography>{item?.company_name ? item?.company_name : "-"}</Typography>
                                            </TableCell>
                                            <TableCell align='center'>
                                                <Box>
                                                    <Button className='eMed_Config_Btn' sx={{ width: '1.7vw', height: '1.7vw' }}
                                                        onClick={() => { this.setState({ isEdit: true }, () => this.onEditHandler(item)) }}
                                                        disabled={!CheckAccessFunc("front_office", "Settings", "OP Service Configuration", "Corporate Service Config", "SubTab")?.editAccess}>
                                                        <Box
                                                            component={'img'}
                                                            src={CheckAccessFunc("front_office", "Settings", "OP Service Configuration", "Corporate Service Config", "SubTab")?.editAccess ? ImagePaths.LabEditButton.default : ImagePaths.DisabledEdit.default}
                                                            height={'1.5vw'} width={'1.5vw'}
                                                        />
                                                    </Button>
                                                    <Button
                                                        disabled={!CheckAccessFunc("front_office", "Settings", "OP Service Configuration", "Corporate Service Config", "SubTab")?.editAccess}
                                                        className='eMed_Config_Btn'
                                                        sx={{ width: '1.7vw', height: '1.7vw' }}
                                                        onClick={() => this.handleDelete(item, true)}
                                                    >
                                                        <Box component={'img'} src={CheckAccessFunc("front_office", "Settings", "OP Service Configuration", "Corporate Service Config", "SubTab")?.editAccess ? ImagePaths.Delete.default : ImagePaths.DisabledDelete.default} height={'1.5vw'} width={'1.5vw'} />
                                                    </Button>
                                                </Box>
                                            </TableCell>
                                            <TableCell>
                                                <IconButton
                                                    size='small'
                                                    onClick={() => {
                                                        this.setState({ selectedIndex: this.state.selectedIndex === index ? null : index })
                                                    }}
                                                >
                                                    {this.state.selectedIndex === index ?
                                                        <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                            <TableRow>{this.renderTbl(item, index)}</TableRow>
                                        </>
                                    </TableBody>
                                ))}
                        </Table>
                    </Box>
                    <TablePagination
                        component='div'
                        id="eMed_tbl_pagination"
                        rowsPerPageOptions={[10, 20, 30]}
                        count={this.state.serviceTempDetail?.length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </Box>
            </Box>
        )
    }

    renderTbl = (item, index) => {
        item?.data?.forEach((element, serviceIndex) => element.sno = serviceIndex + 1)
        return (
            <><TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                <Collapse in={this.state.selectedIndex === index} timeout={'auto'} unmountOnExit>
                    <Box margin={1} className='eMed_Pat_Bill_Tbl_Two'>
                        <Table size='small' stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                        <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={'0.9vw'}>S.No</Typography>
                                    </TableCell>
                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                        <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={'0.9vw'}>Service Name</Typography>
                                    </TableCell>
                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                        <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={'0.9vw'}>Service Type</Typography>
                                    </TableCell>
                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                        <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={'0.9vw'}>Doctor Fee</Typography>
                                    </TableCell>
                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                        <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={'0.9vw'}>Hospital Fee</Typography>
                                    </TableCell>
                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                        <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={'0.9vw'}>Total Amt</Typography>
                                    </TableCell>
                                    <TableCell sx={{ backgroundColor: Colors.Background }}>
                                        <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={'0.9vw'}>Action</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {item?.data?.length > 0 ? item?.data?.map((newItem, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{newItem?.sno}</TableCell>
                                        <TableCell>
                                            <Box display={'flex'}>
                                                {newItem?.service_name ? newItem?.service_name?.length > 12 ?
                                                    <Tooltip placement='top' title={newItem?.service_name}><div>{newItem?.service_name?.slice(0, 10) + '...'}</div></Tooltip> :
                                                    newItem?.service_name : '-'}
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Box display={'flex'}>
                                                {newItem?.service_type ? newItem?.service_type?.length > 12 ?
                                                    <Tooltip placement='top' title={newItem?.service_type}><div>{newItem?.service_type?.slice(0, 10) + '...'}</div></Tooltip> :
                                                    newItem?.service_type : '-'}
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Box display={'flex'}>
                                                {newItem?.doctor_share ? newItem?.doctor_share?.length > 12 ?
                                                    <Tooltip placement='top' title={newItem?.doctor_share}><div>{newItem?.doctor_share?.slice(0, 10) + '...'}</div></Tooltip> :
                                                    newItem?.doctor_share : '0'}
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Box display={'flex'}>
                                                {newItem?.hospital_share ? newItem?.hospital_share?.length > 12 ?
                                                    <Tooltip placement='top' title={newItem?.hospital_share}><div>{newItem?.hospital_share?.slice(0, 10) + '...'}</div></Tooltip> :
                                                    newItem?.hospital_share : '0'}
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Box display={'flex'}>
                                                {newItem?.total_amount ? newItem?.total_amount?.length > 12 ?
                                                    <Tooltip placement='top' title={newItem?.total_amount}><div>{newItem?.total_amount?.slice(0, 10) + '...'}</div></Tooltip> :
                                                    newItem?.total_amount : '0'}
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Button
                                                disabled={!CheckAccessFunc("front_office", "Settings", "OP Service Configuration", "Corporate Service Config", "SubTab")?.editAccess}
                                                className='eMed_Config_Btn'
                                                sx={{ width: '1.7vw', height: '1.7vw' }}
                                                onClick={() => this.handleDelete(newItem)}
                                            >
                                                <Box component={'img'} src={CheckAccessFunc("front_office", "Settings", "OP Service Configuration", "Corporate Service Config", "SubTab")?.editAccess ? ImagePaths.Delete.default : ImagePaths.DisabledDelete.default} height={'1.5vw'} width={'1.5vw'} />
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )) : null}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell></>
        )
    }

    renderRightTable = () => {
        try {
            return (
                <Box margin={'0.5vw'} border={'1px solid lightgray'}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9vw', fontWeight: 600, color: Colors.SecondaryText }}>
                                    Service
                                </TableCell>
                                <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9vw', fontWeight: 600, color: Colors.SecondaryText }}>
                                    Total Amount
                                </TableCell>
                                <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9vw', fontWeight: 600, color: Colors.SecondaryText }}>
                                    Action
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.newServiceList?.length > 0 ? this.state.newServiceList?.map((item, index) => {
                                let serviceName = `${item?.service_type} - ${item?.service_name}`
                                let total_amt = item?.total_amount ? item?.total_amount : item?.total_amt
                                return <TableRow key={index}>
                                    <TableCell>{serviceName?.length > 20 ?
                                        <Tooltip placement="top" title={serviceName}><div>{serviceName?.slice(0, 18) + '...'}</div></Tooltip> :
                                        serviceName}
                                    </TableCell>
                                    <TableCell>{total_amt?.length > 10 ?
                                        <Tooltip placement="top" title={total_amt}><div>{total_amt?.slice(0, 8) + '...'}</div></Tooltip> :
                                        (total_amt ? total_amt : "0")}
                                    </TableCell>
                                    <TableCell>
                                        <CommonEditButton size="1.5vw" onClick={this.newServiceEdit.bind(this, item, index)} />
                                        <CommonDeleteButton size="1.5vw" onClick={this.newServiceDelete.bind(this, item, index)} />
                                    </TableCell>
                                </TableRow>
                            }) : <TableRow>
                                <TableCell />
                                <TableCell>No Records</TableCell>
                            </TableRow>}
                        </TableBody>
                    </Table>
                </Box>
            )
        } catch (error) {
            this.responseSuccessErrorMessage(error.message, false)
        }
    }

    checkDuplicateData = () => {
        try {
            let message = null
            if (this.state.opNewServiceName !== null && this.state.opNewServiceType !== null) {
                this.state.newServiceList?.forEach((element, index) => {
                    let serviceName = this.state.opNewServiceName?.service_name ? CommonValidation.removeSpace(this.state.opNewServiceName?.service_name) : CommonValidation.removeSpace(this.state.opNewServiceName)
                    let serviceType = this.state.opNewServiceType?.service_type ? CommonValidation.removeSpace(this.state.opNewServiceType?.service_type) : CommonValidation.removeSpace(this.state.opNewServiceType)
                    if (index !== this.state.selectedEditIndex) {
                        if (CommonValidation.removeSpace(element.service_name) === serviceName
                            && CommonValidation.removeSpace(element.service_type) === serviceType) {
                            message = "Service Type and Service Name Already exists"
                        }
                    }
                })
            } else {
                message = "Enter Service Name and Service Type"
            }
            return message;
        } catch (error) {
            this.responseSuccessErrorMessage(error.message, false)
        }
    }

    addServiceListData = () => {
        try {
            let states = this.state
            let duplicate = this.checkDuplicateData()
            if (duplicate === null) {
                let updatedData = {
                    ...this.state.opNewServiceName,
                    total_amt: this.state.TotalAmount,
                    doctor_share: this.state.DoctorFee,
                    hospital_share: this.state.HospitalFee,
                    employer_id: this.state.SelectedCorp?.id
                };
                let updatedServiceList = [...(states?.newServiceList || [])];
                if (states?.selectedEditIndex !== undefined && states?.selectedEditIndex !== null) {
                    updatedServiceList[states.selectedEditIndex] = {
                        ids: updatedServiceList[states.selectedEditIndex].ids,
                        ...updatedData
                    };
                } else {
                    updatedServiceList.push(updatedData);
                }
                this.setState({
                    newServiceList: updatedServiceList
                }, () => this.setState({
                    opNewServiceName: null,
                    opNewServiceType: null,
                    selectedEditIndex: null,
                    TotalAmount: "",
                    DoctorFee: "",
                    HospitalFee: "",
                    serviceType: null,
                    isFromRightEdit: false,
                    opNewServiceNameData: [],
                }))
            } else {
                this.responseSuccessErrorMessage(duplicate, false)
            }
        } catch (error) {
            this.responseSuccessErrorMessage(error.message)
        }
    }

    render() {
        const { t } = this.props;
        return (
            <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
                <Grid container spacing={3} className="eMed_srvConfig_Box">
                    <Grid item xs={7.6}>
                        <Box component={'div'} border={'1px solid lightgray'} height={'77.5vh'} sx={{ backgroundColor: 'white' }}>
                            {this.renderLeftContent()}
                        </Box>
                    </Grid>
                    <Grid item xs={4.4}>
                        <Paper className="eMed_srvConfig_Div">
                            <div className='eMed_srvConfig_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                                <p className='eMed_srvConfig_rightHead_txt'>{t("Corporate Service Configuration")}</p>
                            </div>
                            <div className="eMed_srvConfig_subDiv">
                                <Stack spacing={2}>
                                    <Autocomplete
                                        size='small'
                                        options={this.state.corpCompanyList?.map((item) => item)}
                                        getOptionLabel={(option) => (option?.company_name)}
                                        value={this.state.SelectedCorp}
                                        disabled={this.state.isEdit}
                                        onChange={(event, newValue) => {
                                            this.setState({ SelectedCorp: newValue })
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label={t('Select Company Name *')} disabled={this.state.isEdit} style={{ width: "31.5vw", marginLeft: "0.5vw", marginTop: "0.5vw" }} />
                                        )}
                                    />
                                </Stack>
                                <Box component={'div'} mt={'0.65vw'}>
                                    <Box display={'flex'} alignItems={'center'}>
                                        <Autocomplete
                                            clearIcon
                                            size="small"
                                            sx={{ width: '15.5vw', mr: '0.5vw', ml: '0.5vw' }}
                                            options={this.state.opNewServiceTypeData}
                                            disabled={this.state.isEdit && this.state.isFromRightEdit}
                                            getOptionLabel={(options) => typeof (options) === 'string' ? options : options.service_type}
                                            value={this.state.opNewServiceType}
                                            onChange={(e, newValue) => {
                                                this.setState({
                                                    opNewServiceType: newValue,
                                                    opNewServiceNameData: newValue?.data,
                                                    opNewServiceName: null
                                                })
                                            }}
                                            renderInput={(params) => <TextField disabled={this.state.isEdit && this.state.isFromRightEdit} {...params} label='Service Type *' />}
                                        />
                                        <Autocomplete
                                            clearIcon
                                            size="small"
                                            sx={{ width: '15.5vw' }}
                                            options={this.state.opNewServiceNameData}
                                            disabled={this.state.isEdit && this.state.isFromRightEdit}
                                            getOptionLabel={(options) => typeof (options) === 'string' ? options : options.service_name}
                                            value={this.state.opNewServiceName}
                                            onChange={(e, newValue) => {
                                                this.setState({ opNewServiceName: newValue })
                                            }}
                                            renderInput={(params) => <TextField disabled={this.state.isEdit && this.state.isFromRightEdit} {...params} label='Service Name *' />}
                                        />
                                    </Box>
                                </Box>
                                <Box component={'div'} mt={'1.5vw'}>
                                    <TextField
                                        size='small'
                                        sx={{ width: "31.5vw", ml: "0.5vw" }}
                                        disabled={!this.state.opNewServiceName}
                                        label={"Total Amount *"}
                                        name={"TotalAmt"}
                                        value={this.state.TotalAmount}
                                        autoComplete='off'
                                        onChange={(e) => {
                                            let value = e.target.value; let states = this.state
                                            if (CommonValidation.NumberWithDot(value) || value == '') {
                                                states.TotalAmount = +value
                                                states.DoctorFee = ""
                                                states.HospitalFee = ""
                                                this.setState({ states })
                                            }
                                        }}
                                    />
                                </Box>
                                {this.state.opNewServiceName?.service_catagory__catagory_name === "Consultation" || this.state.opNewServiceName?.service_catagory__catagory_name === "OP Procedures" || this.state.serviceType === "Consultation" || this.state.serviceType === "OP Procedures" ?
                                    <Box component={'div'} mt={'0.5vw'} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <TextField
                                            size='small'
                                            sx={{ width: "15.9vw", mr: "0.5vw", ml: "0.5vw" }}
                                            label={"Doctor Fee"}
                                            name={"DoctorFee"}
                                            value={this.state.DoctorFee}
                                            autoComplete='off'
                                            InputProps={{
                                                style: { paddingRight: '0.5vw' },
                                                endAdornment: <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{CurrencySymbol}</Typography>
                                            }}
                                            onChange={(e) => {
                                                let value = e.target.value; let states = this.state
                                                if (CommonValidation.NumberWithDot(value) && value <= states?.TotalAmount || value == '') {
                                                    this.setState({
                                                        DoctorFee: +value,
                                                        HospitalFee: +(states?.TotalAmount - +value).toFixed(2)
                                                    })
                                                }
                                            }}
                                        />
                                        <TextField
                                            size='small'
                                            sx={{ width: "15.9vw", }}
                                            disabled={this.state.TotalAmount == ""}
                                            label={"Hospital Fee"}
                                            name={"HospitalFee"}
                                            value={this.state.HospitalFee}
                                            autoComplete='off'
                                            InputProps={{
                                                style: { paddingRight: '0.5vw' },
                                                endAdornment: <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{CurrencySymbol}</Typography>
                                            }}
                                            onChange={(e) => {
                                                let value = e.target.value; let states = this.state
                                                if (CommonValidation.NumberWithDot(value) && value <= states.TotalAmount || value == '') {
                                                    states.HospitalFee = +value
                                                    this.setState({
                                                        HospitalFee: +value,
                                                        DoctorFee: +(states.TotalAmount - +value).toFixed(2)
                                                    })
                                                }
                                            }}
                                        />
                                    </Box> : null}
                                <Box component={'div'} mt={'0.5vw'} sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Button
                                        disabled={this.state.TotalAmount === ""}
                                        size="small"
                                        variant="contained"
                                        sx={{ textTransform: 'capitalize', height: '2vw' }}
                                        onClick={() => {
                                            if (!this.state.SelectedCorp || !this.state.opNewServiceType || !this.state.opNewServiceName) {
                                                this.responseSuccessErrorMessage("Please Select Mandatory Fields", false);
                                            } else { this.addServiceListData() }
                                        }}
                                    >Add</Button>
                                </Box>
                                <Box component={'div'}>
                                    {this.renderRightTable()}
                                </Box>
                            </div>
                            <Stack spacing={2} direction="row" id='eMed_srvConfig_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
                                <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.handleClear() }}>{t("Clear")}</Button>
                                <Button disabled={!CheckAccessFunc("front_office", "Settings", "OP Service Configuration", "Corporate Service Config", "SubTab")?.editAccess || this.state?.newServiceList?.length <= 0 || this.state.isFromRightEdit} variant='contained' size="small" id="eMed_Config_btn" onClick={() => { this.handleSave() }}>{t("Save")}</Button>
                            </Stack>
                        </Paper>
                    </Grid>
                </Grid>
                {this.state.deletedPopup ?
                    <DeletePopup DeletTitle={`${t("deleteMsg")} ${this.state.srcTemplate_name ? this.state.srcTemplate_name : "-"} ?`}
                        DeleteNotify={t("effectEntireSetting")}
                        deleteAlertPopupClose={this.PopupClose.bind(this)}
                        removeData={this.removeDataList.bind(this)}
                    />
                    : null}
                {
                    this.state.showSuccessResponse ? <ToastMsg severity={"success"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
                }
                {
                    this.state.showErrorResponse ? <ToastMsg severity={"error"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
                }
            </Box>
        )
    }
}
export default withTranslation()(CorporateService);